import { render, staticRenderFns } from "./08-Handle_error.vue?vue&type=template&id=028eb9f6&scoped=true&"
import script from "./08-Handle_error.vue?vue&type=script&lang=js&"
export * from "./08-Handle_error.vue?vue&type=script&lang=js&"
import style0 from "./08-Handle_error.vue?vue&type=style&index=0&id=028eb9f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028eb9f6",
  null
  
)

export default component.exports